import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useDecodeContextLocation = context => {
	const location = useLocation();
	const memoized = useMemo(() => context?.queryDecoder(location), [context, location]);
	return memoized;
};

export default useDecodeContextLocation;
